import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './PepEmploymentEditor.html?raw';

import SelectBox from '../../../moreCore/UI/SelectBox/SelectBox';

import PepHome from '../PepRosterStart';
import HintBox from '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import { ColorHelpers, FeatureHelpers, StringHelpers, TranslationHelpers } from "../../../more/Helpers";
import PageStack from '../../../moreCore/UI/Tabbing/PageStack';
import GenericEntityView from '../../../moreCore/UI/EntityBased/EntityView/GenericEntityView';
import { PEP } from "../PepTypes";


interface _PepEditorCostUnit { ID: string, code: string }

interface _EmploymentEditorSettings {
    breaksCount: number
}

interface BreakRegEntry {
    data: PEP.EmploymentBreak,
    inputStart: HTMLInputElement,
    inputEnd: HTMLInputElement,
    inputDuration: HTMLInputElement,
    parentContainer: HTMLElement,
    messageContainer: HTMLElement,
    valid: boolean

}

class PepEmploymentEditor extends compose(_WidgetBaseSP) {
	templateString: any = template;

    isDirty: boolean = false;
    private _initialised: boolean = false;
    private _data: PEP.EmploymentData = null;
    private _cell: PEP.Cell = null;
    private callback: Function;
    xData: PEP.XAxisDescriptor = null;
    yData: PEP.YAxisDescriptor = null;

    private _PepHome: MdsLax<InstanceType<typeof PepHome>> = null;

    private CostUnit1: _PepEditorCostUnit = null;
    private CostUnit2: _PepEditorCostUnit = null;
    private CostUnit3: _PepEditorCostUnit = null;

    private resultData: PEP.ResultData = null;
    private _originalDatastring: string;
    private _serializeDataTimeout: any = null;
    private selectedEmploymentType: PEP.EmploymentType = null;
    private selectedBookingStatus: PEP.EmploymentBookingStatus = null;

    private isVirtual: boolean = false;
    private isDraft: boolean = false;
    private isDeleting: boolean = false;
    private isLocked: boolean = false;
    public isActive: boolean = false;
    private isOverrideTime: boolean = false;

    private submitMode: PEP.SubmitEntryMode;
    private partialEditorData: Partial<PEP.EditorData>;

    private inputEmploymentType: MdsLax<InstanceType<typeof SelectBox>>;
    private inputBookingStatus: MdsLax<InstanceType<typeof SelectBox>>;
    private inputIsOnDuty: MdsLax<InstanceType<typeof CheckBox>>;
    private inputNoBreak: MdsLax<InstanceType<typeof CheckBox>>;
    private inputIsTimesConfirmed: MdsLax<InstanceType<typeof CheckBox>>;
    private inputTimeStart: HTMLInputElement;
    private inputTimeEnd: HTMLInputElement;
    private inputBreakDuration: HTMLInputElement;
    private btnOK: HTMLButtonElement;
    private btnCancel: HTMLButtonElement;
    private btnDelete: HTMLButtonElement;
    private btnRevert: HTMLButtonElement;
    private btnPipette: HTMLButtonElement;
    private inputNotes: HTMLTextAreaElement;
    private inputNotesInternal: HTMLTextAreaElement;
    private notesLabelNode: HTMLLabelElement;
    private notesTooltip: HTMLDivElement;
    private noteInternalIcon: HTMLElement;
    private notesInternalTooltip: HTMLDivElement;
    private employmentNotesContainer: HTMLDivElement;
    private employmentNotesInternalContainer: HTMLDivElement;
    private employmentConfirmationContainer: HTMLDivElement;
    private employmentConfirmationLabels: HTMLDivElement;
    private sectionBreak: HTMLDivElement;
    private actionContainer: HTMLDivElement;
    private editorFrame: HTMLDivElement;
    private txtTimesConfirmedBy: HTMLElement;
    private txtTimesConfirmedAt: HTMLElement;
    private txtTimesManagedByBackend: HTMLElement;

    private sectionNoBreak: HTMLElement;
    private sectionIsOnDuty: HTMLElement;
    private breaksContainer: HTMLElement;
    private sectionMultipleBreaks: HTMLElement;
    private sectionSingleBreak: HTMLElement;
    private sectionEmploymentTimesCheckMessages: HTMLElement;
    private txtWarningMessageEmploymentTimes: HTMLElement;

    private breaksReg: Array<BreakRegEntry>;


    private inputCostUnit1: MdsLax<InstanceType<typeof HintBox>>;

    private useCostUnits: boolean = false;
    private useEntityView: boolean = false;
    private useMultipleBreaks: boolean = false;
    private _settings: Partial<_EmploymentEditorSettings> = {
        breaksCount: 0
    };

    private entityview: MdsLax<InstanceType<typeof GenericEntityView>>;

    private windowEx: PEP.WindowEx;
    
    private _setDataAttr(data: PEP.EmploymentData): void {
        this.setData(data);
    }
    setData(data: PEP.EmploymentData, editedData?: PEP.EditorData) {
        this.partialEditorData = {};
        if (data) {
            this._data = lang.clone(data);

            // falls vom vorherigen Durchgang schon Änderungen aus den Editordaten vorhanden sind, diese auf die Employmentdata überschreiben:
            if (editedData) {
                let editorData = lang.clone(editedData);

                let target = this._data;

                if (this.useCostUnits) {
                    if (target.ref_cost_unit_1?.ID != editorData.costUnit1ID) target.ref_cost_unit_1 = { code: "?", ID: editorData.costUnit1ID, gDisp: "??" };
                    if (target.ref_cost_unit_2?.ID != editorData.costUnit2ID) target.ref_cost_unit_2 = { code: "?", ID: editorData.costUnit2ID, gDisp: "??" };
                    if (target.ref_cost_unit_3?.ID != editorData.costUnit3ID) target.ref_cost_unit_3 = { code: "?", ID: editorData.costUnit3ID, gDisp: "??" };
                }
                target.ref_empl_booking_status = editorData.bookingStatusID;
                target.ref_task_definition = editorData.taskDefinitionID;
                target.ref_type = editorData.employmentTypeID;

                target.is_on_duty = editorData.is_on_duty
                target.is_oversteered_duration = editorData.is_oversteered_duration;
                target.is_oversteered_time = editorData.is_oversteered_time;
                //target.is_pause_payed = editorData.
                target.is_times_confirmed = editorData.is_times_confirmed;

                target.note_warnings = editorData.warningMessage;

                
                //target.start
                target.startTXT = editorData.startTXT;

                //target.end
                target.endTXT = editorData.endTXT;

                if (this.useMultipleBreaks) {
                    target.breaks = editorData.breaks; // ist ja bereits geklont
                }
                //target.duration_pause
                target.pauseTXT = editorData.pauseTXT;
            }

            //this.applyData();
        }
        this.continueApplyData();
    }

    private continueApplyData(): void {
        if (this._initialised == true && this._data != null) {
            this.applyData();
        }
    }

    setLocked(bLock?: boolean) {
        this.setReadonly(bLock);
    }

    setReadonly(bReadonly?: boolean) {
        if (bReadonly !== false && bReadonly !== true) {
            bReadonly = true;
        }

        this.isLocked = bReadonly; // nur Brot. chchch.

        this.setReadonlyStyle();
    }

    private setReadonlyStyle(): void {
        this.inputEmploymentType.setReadonly(this.isLocked);
        this.inputBookingStatus.setReadonly(this.isLocked || !this._data.EditEmplBookingStatus);

        this.inputCostUnit1.setReadonly(this.isLocked);

        this.inputIsTimesConfirmed.setReadonly(this.isLocked || !this._data.EditIsTimeConfirmed);

        let type = this.selectedEmploymentType;
        let bCanEditTimes = type && type.is_can_oversteer_time_values == true && this.isLocked != true;

        
        let bDisable = true;

        if (this.isLocked != true && this.isDeleting != true) {
            bDisable = false;
        }
        this.UiModder.domClass.add(this.domNode, "locked");
        this.disableNode(this.inputIsOnDuty, bDisable);
        this.disableNode(this.inputNoBreak, bDisable);
        this.disableNode(this.inputIsTimesConfirmed, bDisable),

        this.disableNode(this.inputNotes, bDisable);
        this.disableNode(this.inputNotesInternal, bDisable);

        this.hideNode(this.actionContainer, bDisable);

        this.disableNode(this.inputTimeStart, !bCanEditTimes || bDisable);
        this.disableNode(this.inputTimeEnd, !bCanEditTimes || bDisable);
        this.disableNode(this.inputBreakDuration, !bCanEditTimes || this.useMultipleBreaks || bDisable);
        this.disableNode(this.sectionMultipleBreaks, !bCanEditTimes || !this.useMultipleBreaks || bDisable);

        if (this.useEntityView) {
            if (this.entityview) this.entityview.setNonInteractive(!!this.isLocked || !!this.isVirtual || !!this.isDeleting || !!this.isDirty)
        }

        this.setButtonStyles();
    }

    show(data: PEP.EmploymentData, callback: Function, cell: PEP.Cell, editedData?: PEP.EditorData, forceInit?: boolean, target?: "editor" | "entityview" | "previous") {
        this._cell = cell;
        this.callback = callback;

        if (!this._initialised && forceInit === true) this._initValuesFromRegistry();
        
        this.applyData(data, editedData);
        this.isActive = true;

        this.setupHintboxes();

        this.UiModder.domStyle.set(this.domNode, "display", "block");

        let useUrlParams = FeatureHelpers.hasFeature("PEP/useUrlParams");


        if (this.isVirtual != true && useUrlParams == true) {
            this.setUrlParameter(PEP.UrlParameter.targetID, data.ID);
            this.setUrlParameter(PEP.UrlParameter.targetType, "employment");
        }

        //console.debug("employment editor show", this.domNode);

        let actualTarget = "editor";
        if (target == "previous") target = this._previousPageName as any;

        switch (target) {
            case "entityview":
                if (this.useEntityView) actualTarget = target;
                break;

            default:
                actualTarget = "editor";
                break;
        }


        this._pageStack.switchToPage(actualTarget);
    }


    closeAndSubmit(result?: number) {
        if (this.isActive != true) {
            return;
        }

        if (this._getPauseRequest != null) {
            // nicht zulassen wenn noch die Pause abgefragt wird!
            return;
        }

        this.removeUrlParameter(PEP.UrlParameter.targetID);
        this.removeUrlParameter(PEP.UrlParameter.targetType);

        //console.debug("editor closeAndSubmit result - virtual? - draft?", result, this.isVirtual, this.isDraft, this.newData);

        this.UiModder.domConstruct.place(this.domNode, document.body);

        this.isActive = false;
        this.UiModder.domStyle.set(this.domNode, "display", "");

        if (result == 1) { // ok / speichern / übernehmen
            
        } else { // Abbruch / schließen
            
        }

        if (typeof (this.callback) == "function") {
            this.callback(result, this.resultData);
        }

        this.emit("submit", this.resultData);
        
        this._data = null;
    }

    private setWarningMessage(message: string) {
        if (message) {
            this.UiModder.domAttr.set(this.txtWarningMessageEmploymentTimes, "innerHTML", message);
            this.hideNode(this.sectionEmploymentTimesCheckMessages, false);
        } else {
            this.hideNode(this.sectionEmploymentTimesCheckMessages);
        }
    }

    private applyData(newData?: PEP.EmploymentData, editedData?: PEP.EditorData): void {
        
        if (typeof (newData) != "undefined") {
            this.setData(newData, editedData);
            return; // via set kommt eh das Apply daher....
        }

        //console.debug("employmenteditor applyData", this._data);

        let data = this._data;

        this.inputIsOnDuty.setValue(data.is_on_duty === true, true);
        this.inputNoBreak.setValue(data.is_no_break === true, true);

        let notes = "";
        if (this._cell?.infoData?.dayRecordInfo) {
            for (let note of this._cell.infoData.dayRecordInfo.notes) { // blödes Format: das Array ist eigentlich nur ein Eintrag für Tagesanmerkung.
                notes += note;
                break;
            }
        }

        this.inputNotes.value = notes;
        this.notesTooltip.innerHTML = notes;
        this.UiModder.domClass.toggle(this.employmentNotesContainer, "empty", !notes);
        this.UiModder.domClass.toggle(this.employmentNotesContainer, "enableTooltip", !!notes);
        this.hideNode(this.employmentNotesContainer, !notes);
        this.UiModder.domClass.remove(this.employmentNotesContainer, "hover");

        let noteInternal = this._cell?.infoData?.dayRecordInfo?.note_internal_use;
        this.hideNode(this.employmentNotesInternalContainer, !noteInternal);
        if (this._cell?.infoData) {            
            this.inputNotesInternal.value = noteInternal ? noteInternal : "";
            this.notesInternalTooltip.innerHTML = noteInternal;
            this.UiModder.domClass.toggle(this.employmentNotesInternalContainer, "enableTooltip", !!noteInternal);
            this.UiModder.domClass.toggle(this.employmentNotesInternalContainer, "empty", !noteInternal);
            this.UiModder.domClass.remove(this.employmentNotesInternalContainer, "hover");
        }
        //this.hideNode(this.inputNotesInternal, !this._data.CanEditNoteInternalUse);

        this.setWarningMessage(data.note_warnings);

        this.isDraft = typeof (data.draft) == "boolean" ? data.draft : false;
        this.isVirtual = typeof (data.virtual) == "boolean" ? data.virtual : false;
        this.isDeleting = typeof (data.deleting) == "boolean" ? data.deleting : false;

        if (this.isVirtual === true) {
            this.submitMode = PEP.SubmitEntryMode.create;

        } else {
            this.submitMode = PEP.SubmitEntryMode.change;
        }

        if (data.ref_type != null && data.ref_type != "") {
            this.inputEmploymentType.setValue(data.ref_type, true);
        }  else {
            this.inputEmploymentType.setValue("", true);
        }

        this.inputIsTimesConfirmed.setValue(data.is_times_confirmed, true);
        this.hideNode(this.employmentConfirmationLabels);
        this.hideNode(this.txtTimesConfirmedAt);
        if (data.is_times_confirmed === true) {
            this.setTimesConfirmedByLabel(data.times_confirmed_by);
            if (data.date_time_confirmed_at) {
                this.txtTimesConfirmedAt.innerHTML = data.date_time_confirmed_at;
                this.UiModder.domClass.remove(this.txtTimesConfirmedAt, "obsolete w3-hide");
            }
            this.hideNode(this.employmentConfirmationLabels, false);
        }

        this.hideNode(this.employmentConfirmationContainer, this.isVirtual);

        this.setDataFromSelectedTemplate();

        this.isOverrideTime = data.is_oversteered_time;
        this.inputTimeStart.value = data.startTXT;
        this.inputTimeEnd.value = data.endTXT;
        let pause = data.duration_pause ? data.duration_pause.toFixed(2) : null;
        pause ? this.inputBreakDuration.value = pause : this.inputBreakDuration.value = "";

        if (this.useMultipleBreaks) {
            this._drawBreaks(data.breaks)
        }

        //console.debug("editor applyData", this._data, data.duration_pause, pause);

        if (data.ref_empl_booking_status) {
            this.inputBookingStatus.setValue(data.ref_empl_booking_status, true);
        } else if (this.isVirtual == true) {
            this.inputBookingStatus.setValue(this.windowEx.PepRegistry.defaultEmploymentBookingStatus, true);
        } else {
            this.inputBookingStatus.setValue("", true);
        }
        
        this.setDataFromSelectedBookingStatus();

        this._originalDatastring = null;
        this._serializeData();
        this._originalDatastring = JSON.stringify(this.resultData);
        this.setEmploymentTypeStyle();
        this.setReadonlyStyle();

        this.checkDirty();

        //this._pageStack.switchToPage("editor");

        if (this.useEntityView) {
            this.UiModder.domConstruct.empty(this.sectionEntityView);
            if (this.isVirtual) {
                this._pageStack.hidePage("entityview");
            } else {
                let ev = new GenericEntityView();
                ev.setContextName("PEPemploymentEditor");
                
                ev.setNonInteractive(!!this.isLocked || !!this.isDirty || !!this.isDeleting);
                ev.setup(this._data.ID, this._data.Classname, null, null, this.sectionEntityView);
                this._pageStack.hidePage("entityview", false);

                ev.on("change", lang.hitch(this, this._onChange_EntityView));

                this.entityview = ev;
            }
        }
    }

    private _onChange_EntityView() {
        // jetzt müsste sich die Zelle und der Editor eigentlich komplett neu laden...
        this.emit("update");
    }

    private _serializeDataDelayed(timeout?: number): void{
        if (this._serializeDataTimeout != null) {
            clearTimeout(this._serializeDataTimeout);
            this._serializeDataTimeout = null;
        }

        if (typeof (timeout) == "undefined") {
            timeout = 333;
        }

        this._serializeDataTimeout = setTimeout(lang.hitch(this, this._serializeData), timeout);
    }

    private _serializeData(): void {

        if (this._serializeDataTimeout != null) {
            clearTimeout(this._serializeDataTimeout);
            this._serializeDataTimeout = null;
        }

        let emplID = this.inputEmploymentType.getValue();
        let emplType = this.windowEx.PepRegistry.employmentTypes[emplID];
        let mainLabel = "?";
        let shortLabel = mainLabel;
        let startTXT = this.inputTimeStart.value;
        let endTXT = this.inputTimeEnd.value;

        if (emplType) {
            mainLabel = this.stringFormat(emplType.mainLabelFormat, emplType.description,startTXT, endTXT);
            shortLabel = emplType.code;
        }
        
        this.resultData = {
            editedData: {
                employmentTypeID: emplID,
                bookingStatusID: this.inputBookingStatus.getValue(),
                costUnit1ID: this.CostUnit1 ? this.CostUnit1.ID : null,
                costUnit2ID: this.CostUnit2 ? this.CostUnit2.ID : null,
                costUnit3ID: this.CostUnit3 ? this.CostUnit3.ID : null,
                xID: this._data.xID,
                yID: this._data.yID,
                ID: this._data.ID,
                startTXT: startTXT,
                endTXT: endTXT,
                mainLabel: mainLabel,
                shortLabel: shortLabel,
                warningMessage: this._data.note_warnings,
                pauseTXT: this.inputBreakDuration.value ? this.inputBreakDuration.value : "",
                is_oversteered_time: this.isOverrideTime,
                is_on_duty: this.inputIsOnDuty.getValue() == true,
                is_no_break: this.inputNoBreak.getValue() == true,
                is_oversteered_duration: this._data.is_oversteered_duration, // keine Änderung ...
                taskDefinitionID: this._data.ref_task_definition,
                //notes: this.inputNotes.value,
                is_times_confirmed: this.inputIsTimesConfirmed.getValue() == true
            },
            mode: this.submitMode,
            //node: null
        };

        // falls auf der partial-Data noch keys stehen, dann diese auf die edited-Data übernehmen
        // ansonsten werden teilweise bereits aktualisierte Properties (während des editor-Vorgangs) wieder auf this._data (der ursprünglichen Data) übernommen
        if (this.partialEditorData) {
            for (let key in this.partialEditorData) {
                let value = this.partialEditorData[key];
                if (value != null && typeof (value) != "undefined") {
                    this.resultData.editedData[key] = lang.clone(value);
                } else {
                    this.resultData.editedData[key] = value;
                }
            }
        }

        if (this.breaksReg?.length && this.useMultipleBreaks == true) {
            let durationTotal: number = 0;

            this.resultData.editedData.breaks = [];
            for (let brk of this.breaksReg) {
                if (brk.data.durationMin) {
                    durationTotal += brk.data.durationMin;
                }
                this.resultData.editedData.breaks.push({
                    ...brk.data
                });
            }

            if (durationTotal && durationTotal >= 0) {
                let durationTotalH = durationTotal / 60;
                this.inputBreakDuration.value = durationTotalH.toFixed(2);
            }

        }

        //if (this._data.CanEditNoteInternalUse === true) {
        //    this.newData.editedData.note_internal_use = this.inputNotesInternal.value;
        //}

        //console.debug("convertNewData", this.newData);
        if (this._originalDatastring != null) {
            this.checkDirty();
        }
    }

    private checkDirty(): void {
        let currentData: string = JSON.stringify(this.resultData);
        let isDirty: boolean = this._originalDatastring != currentData;
        this.isDirty = isDirty;

        //console.debug("editor checkdirty", isDirty, this._originalDatastring, currentData);

        this.setButtonStyles();
    }

    private setButtonStyles(overrideOK?: boolean): void {

        //console.debug("setButtonStyles - draft - virtual - dirty - locked - data dirty - type",
        //    this.isDraft,
        //    this.isVirtual,
        //    this.isDirty,
        //    this.isLocked,
        //    this._data.dirty,
        //    this.selectedEmploymentType.code);

        let isRemoveAllowed = this.isDraft != true && this.isDirty != true && this.isLocked != true && this.isDeleting != true;
        //isRemoveAllowed || this.isDraft == true; // ... oder es ist ein Entwurf (neuer Eintrag)
        this.disableNode(this.btnDelete, isRemoveAllowed !== true);

        let isCancelAllowed = true;
        this.disableNode(this.btnCancel, isCancelAllowed !== true);

        let breaksValid = true;
        if (this.useMultipleBreaks && this.breaksReg) {
            for (let brk of this.breaksReg) {
                if (brk.valid != true) {
                    breaksValid = false;
                    break; // break break break breaks :)
                }
            }
        }
        
        let isSubmitAllowed = (this.isDraft == true || this.isDirty == true) &&
            this.isLocked != true &&
            breaksValid == true &&
            this.selectedEmploymentType != null &&
            this.selectedBookingStatus != null;

        if (overrideOK === true || overrideOK === false) isSubmitAllowed = overrideOK;

        this.disableNode(this.btnOK, isSubmitAllowed !== true);

        let isPipetteAllowed = this.selectedEmploymentType != null && this.selectedBookingStatus != null;
        
        this.disableNode(this.btnPipette, isPipetteAllowed !== true);

        let isRevertAllowed = this.isVirtual != true && this._data.dirty == true && this.isDirty != true; // bestehender Datensatz, wurde aber schon mal geändert
        //isRevertAllowed = isRevertAllowed || this.isDraft == true; // ... oder es ist ein Entwurf (neuer Eintrag)
        
        this.disableNode(this.btnRevert, isRevertAllowed !== true);
           
    }

    private setEmploymentTypeStyle(): void {
        let typeID = this.inputEmploymentType.get("value");
        let color: string = "#fff";
        let type: PEP.EmploymentType = null;
        if (typeID) type = this.windowEx.PepRegistry.employmentTypes[typeID];

        if (type) color = type.coloration.BackColor.Hex;



        //for (let type of this.windowEx.PepRegistry.employmentTypes) {
        //    if (type.ID == typeID) {
        //        color = type.coloration.BackColor.Hex;

        //        if (type.is_can_oversteer_time_values == true && this.isLocked != true) {
        //            fct1 = this.UiModder.domClass.remove;
        //        }
        //        break;
        //    }
        //}

        //this.UiModder.domStyle.set(this.editorFrame, "backgroundColor", color);
        this.domNode.style.setProperty("--colorBG", color);
        let hexColor = ColorHelpers.getHexColorFromString(color);
        let bIsDarkBG;
        if (hexColor) {
            if (ColorHelpers.isDarkColor(hexColor)) {
                bIsDarkBG = true;
            }
        }
        this.UiModder.domClass.toggle(this.domNode, "darkBG", bIsDarkBG);

        this.setReadonlyStyle();
    }

    private setDataFromSelectedTemplate(): void {

        let selectedType: PEP.EmploymentType = null;
        let selectedID: string = this.inputEmploymentType.getValue();

        if (selectedID) selectedType = this.windowEx.PepRegistry.employmentTypes[selectedID];
        //for (let _employmentType of this.windowEx.PepRegistry.employmentTypes) {
        //    if (_employmentType.ID == selectedID) {
        //        selectedType = _employmentType;
        //        break;
        //    }
        //}

        this.selectedEmploymentType = selectedType;
        this.hideNode(this.txtTimesManagedByBackend, true);
        if (selectedType != null && this.isOverrideTime != true) {
            this.inputTimeStart.value = selectedType.startTXT;
            this.inputTimeEnd.value = selectedType.endTXT;

            if (selectedType.is_get_time_from_empl_contract === true && (this._data?.ref_type != selectedType.ID /* dirty ist hier noch nicht gesetzt */ || this.isVirtual)) {
                // weil wir nicht alle Daten des Vertrags auch noch mitschleifen können, hier nur der Hinweis dass sich um die Zeiten im Backend gekümmert wird:
                this.hideNode(this.txtTimesManagedByBackend, false);
            }

            let pause = selectedType.pause_duration_default ? selectedType.pause_duration_default.toFixed(2) : null;
            pause ? this.inputBreakDuration.value = pause : this.inputBreakDuration.value = "";
        }        
        
        this._drawBreaks(selectedType?.breaks);

        //console.debug("editor setDataFromSelectedTemplate", selectedID, selectedType);

    }


    private _drawBreaks(breaks: Array<PEP.EmploymentBreak>) {
        this.breaksReg = [];
        this.UiModder.domConstruct.empty(this.breaksContainer)

        this.hideNode(this.sectionMultipleBreaks);

        if (this.useMultipleBreaks == true) {

            this.hideNode(this.sectionMultipleBreaks, false);

            if (!breaks?.length) {
                breaks = [];
            }


            let dummyBreak: PEP.EmploymentBreak = {
                endTxt: null,
                startTxt: null,
                _refDate: null,
                durationMin: null
            };

            while (breaks.length < this._settings.breaksCount) {
                breaks.push(lang.clone(dummyBreak));
                if (breaks.length > 99) break; // Notfall-Ausstieg
            }
            this.hideNode(this.breaksContainer, !breaks.length);

            let index = 0;
            for (let brk of breaks) {

                
                let node = this.UiModder.domConstruct.create("div", {
                    className: "break border round paddingSmall brightTransparentBG",
                }, this.breaksContainer);

                let labelBreak = this.UiModder.domConstruct.create("label", {
                    innerHTML: StringHelpers.stringFormat(TranslationHelpers.translate("PEP_EmploymentEditor__LblBreakNo"), index + 1),
                    className: "bold"
                }, node);

                let row = this.UiModder.domConstruct.create("div", {
                    className: "timesRow"
                }, node);

                let startContainer = this.UiModder.domConstruct.create("div", { className: "times" }, row);

                let labelStart = this.UiModder.domConstruct.create("label", {
                    innerHTML: StringHelpers.stringFormat( TranslationHelpers.translate("PEP_EmploymentEditor__LblBreakFrom" ), index + 1 ),
                }, startContainer)

                let inputStart = this.UiModder.domConstruct.create("input", {
                    className: "inputStart",
                    type: "time",
                    id: "inputBreakStart-" + index,
                }, startContainer) as HTMLInputElement;

                on(inputStart, "change", lang.hitch(this, this._onChangeBreakTime, index));

                // Value eintragen!
                if (brk.startTxt) {
                    let parts = brk.startTxt.split(":");
                    if (parts.length == 2) {
                        inputStart.value = brk.startTxt;
                    }
                }

                let endContainer = this.UiModder.domConstruct.create("div", { className: "times" }, row);

                let labelEnd = this.UiModder.domConstruct.create("label", {
                    innerHTML: StringHelpers.stringFormat(TranslationHelpers.translate("PEP_EmploymentEditor__LblBreakTo"), index + 1),
                }, endContainer)

                let inputEnd = this.UiModder.domConstruct.create("input", {
                    className: "inputEnd",
                    type: "time",
                    id: "inputBreakEnd-" + index,
                }, endContainer) as HTMLInputElement;

                on(inputEnd, "change", lang.hitch(this, this._onChangeBreakTime, index));

                let messageContainer = this.UiModder.domConstruct.create("div", { className: "message" }, node);
                

                // Value eintragen!
                if (brk.startTxt) {
                    let parts = brk.endTxt.split(":");
                    if (parts.length == 2) {
                        inputEnd.value = brk.endTxt;
                    }
                }

                index++;

                let breakReg = {
                    data: {
                        ...brk
                    },
                    inputDuration: null,
                    inputStart: inputStart,
                    inputEnd: inputEnd,
                    parentContainer: node,
                    messageContainer: messageContainer,
                    valid: true
                };
                this.breaksReg.push(breakReg);

            }
        }
    }

    private setDataFromSelectedBookingStatus(): void {
        let selectStatus: PEP.EmploymentBookingStatus = null;
        let selectedID: string = this.inputBookingStatus.get("value");

        if (selectedID) selectStatus = this.windowEx.PepRegistry.employmentBookingStatus[selectedID];

        //for (let _bookingStatus of this.windowEx.PepRegistry.employmentBookingStatus) {
        //    if (_bookingStatus.ID == selectedID) {
        //        selectStatus = _bookingStatus;
        //        break;
        //    }
        //}

        //console.debug("editor setDataFromSelectedBookingStatus", selectedID, selectStatus);

        this.selectedBookingStatus = selectStatus;
    }
    //forceInit() {
    //    this._initValuesFromRegistry();
    //}
    private _initValuesFromRegistry(): void {
        //console.debug("editor _initValuesFromRegistry", this.windowEx.PepRegistry.employmentTypes);
        
        if (this._initialised == true) {
            this.inputEmploymentType = new SelectBox(); // wenns schon mal initialisiert war, dann eine neue erstellen
            this.inputBookingStatus = new SelectBox(); // wenns schon mal initialisiert war, dann eine neue erstellen
        }

        for (let key in this.windowEx.PepRegistry?.employmentTypes) {
            let _employmentType = this.windowEx.PepRegistry.employmentTypes[key];

            this.inputEmploymentType.addEntry(_employmentType.ID, _employmentType.description, true, _employmentType.coloration?.BackColor.Hex, _employmentType.coloration?.TextColor.Hex);
        }
        this.inputEmploymentType.setBlankOption("", "PEP_EmploymentEditor__LblEmploymentType_blank", false);
        this.inputEmploymentType.constructOptions();

        for (let key in this.windowEx.PepRegistry?.employmentBookingStatus) {
            let _bookingStatus = this.windowEx.PepRegistry.employmentBookingStatus[key];
            this.inputBookingStatus.addEntry(_bookingStatus.ID, _bookingStatus.description);
        }
        this.inputBookingStatus.setBlankOption("", "PEP_EmploymentEditor__LblBookingStatus_blank", false);
        this.inputBookingStatus.constructOptions();

        //console.debug("editor _initValuesFromRegistry finished");

        this._initialised = true;

        this.continueApplyData();
    }

    private _onChangeBreakTime(breakIndex: number) {
        if (this.isLocked) return;
        let delay = 2000;
        if (breakIndex >= 0) {
            let reg = this.breaksReg[breakIndex];
            if (!reg) return;

            //console.debug("_onChangedBreak", reg);

            let currentStartVal = reg.inputStart.value;
            let currentEndVal = reg.inputEnd.value;

            reg.data.startTxt = currentStartVal;
            reg.data.endTxt = currentEndVal;

            if (reg.data.startTxt && reg.data.endTxt) delay = 400;

            this.isOverrideTime = true;

            this._serializeData();
        }

        this.checkEmploymentTimes(delay);

        this.UiModder.domClass.add(this.sectionMultipleBreaks, "unchecked");
    }

    private abortCheckEmploymentTimes() {
        if (this._checkEmploymentTimesTimeout) {
            clearTimeout(this._checkEmploymentTimesTimeout);
        }
        if (this._checkEmploymentTimesRequest) {
            try {
                this._checkEmploymentTimesRequest.cancel();
            } catch (ex) {

            }
        }

        this.UiModder.domClass.remove(this.sectionMultipleBreaks, "checking");

        this._checkEmploymentTimesRequest = null;
        this._checkEmploymentTimesTimeout = null;
    }

    private checkEmploymentTimes(delay: number = 600) {
        this.abortCheckEmploymentTimes();

        this._checkEmploymentTimesTimeout = setTimeout(lang.hitch(this, this._checkEmploymentTimes), delay >= 0 ? delay : 600);
        this.setButtonStyles(false);
    }

    private _checkEmploymentTimesRequest: dojo.request.Promise<{}> = null;
    private _checkEmploymentTimesTimeout: number = null;
    private _checkEmploymentTimes(): void {
        if (this._checkEmploymentTimesTimeout) {
            clearTimeout(this._checkEmploymentTimesTimeout);
        }
        this.UiModder.domClass.add(this.sectionMultipleBreaks, "checking");


        //this.StandbyStart(this.sectionBreak);

        let data = this.resultData;

        this._checkEmploymentTimesRequest = this.RequestManager.callfunction(
            "Webtool_API_PEP__CheckEmploymentTimes",
            data,
            lang.hitch(this, this._onCheckEmploymentTimesResponse),
            lang.hitch(this, this._onCheckEmploymentTimesError),
            false // sync
        );
    }

    private _onCheckEmploymentTimesResponse(response: {
        breaks: Array<{
            durationMin: number,
            valid: boolean,
            // recommendedStartTXT: string,
            // recommendedEndTXT: string
        message: string
        }>,
        durationTotalMin: number
        durationBreakMinimal: number
        warningMessage: string
    }): void {
        this._checkEmploymentTimesRequest = null;

        let index = -1;
        let bValid = true;
        if (response.breaks?.length == this.breaksReg.length && typeof (response.breaks.length) == "number" && this.useMultipleBreaks == true) {
            for (let breakResult of response.breaks) {
                index++;
                let brk = this.breaksReg[index];

                this.UiModder.domClass.toggle(brk.parentContainer, "invalid", breakResult.valid != true);
                brk.valid = breakResult.valid;
                brk.data.durationMin = breakResult.durationMin;
                bValid = bValid && breakResult.valid;

                this.UiModder.domAttr.set(brk.messageContainer, "innerHTML", breakResult.message);

                // // falls das Backend bei Prüfung vorgeschlagene Pausenzeiten schickt, diese übernehmen
                // if (this.isVirtual && FeatureHelpers.hasFeature("PEP/UseRecommendedBreakTimesOnCheck")) {
                    
                //     if (typeof (breakResult.recommendedStartTXT) == "string" && typeof (breakResult.recommendedEndTXT) == "string") {
                //         brk.inputStart.value = breakResult.recommendedStartTXT;
                //         brk.inputEnd.value = breakResult.recommendedEndTXT;
                //     } else if (breakResult.recommendedStartTXT === null && breakResult.recommendedEndTXT === null) { // nicht undefined erlauben!
                //         brk.inputStart.value = null;
                //         brk.inputEnd.value = null;
                //     }
                // }
            }

            if (typeof (response.durationTotalMin) == "number") {
                let durationH = response.durationTotalMin / 60;
                this.inputBreakDuration.value = durationH.toFixed(2);
            } else {
                this.inputBreakDuration.value = "";
            }
        } else {
            bValid = false;
            this.showToast("PEP_EmploymentEditor__MultipleBreaksResponseMalformed", toasterIcons.warning);
        }

        if (typeof (response.durationBreakMinimal) == "number") {

        }
        this.setWarningMessage(response.warningMessage);
        this.partialEditorData.warningMessage = response.warningMessage;

        this.disableNode(this.actionContainer, false);

        if (!bValid) {
            this.setButtonStyles(false);
        }
        else {
            this._serializeData();
            //this.checkDirty();
        }

        this.emit("change", this.resultData.editedData);

        this.UiModder.domClass.remove(this.sectionMultipleBreaks, "checking unchecked");
    }

    private _onCheckEmploymentTimesError(response: more.requestErrorMessage): void {
        this._checkEmploymentTimesRequest = null;
        
        this.disableNode(this.actionContainer, false);

        alert("Zeitenprüfung fehlgeschlagen!\r\n" + response.Message);

        console.error("_onCheckEmploymentTimesError", response.Message);
    }
    private _getPauseRequest: dojo.request.Promise<{}> = null;
    

    private _onClick_Delete(evt: MouseEvent) {
        evt.stopPropagation();
        //console.debug("_onClick_Delete", this.isLocked, this._data, this.isActive);

        if (this.isLocked == true) {
            return;
        }
        if (this._data == null) {
            return;
        }

        if (this.isVirtual === true) {
            this.closeAndSubmit(-1);
            return;
        }

        this.submitMode = PEP.SubmitEntryMode.delete;
        this._serializeData();
        this.closeAndSubmit(1);
    }

    private _onClick_Cancel(evt: MouseEvent) {
        evt.stopPropagation();

        if (this.isDraft === true) {
            this.closeAndSubmit(-1);
            return;
        }

        this.closeAndSubmit(0);
    }

    private _onClick_Revert(evt: MouseEvent) {
        evt.stopPropagation();

        this.closeAndSubmit(-1);
    }

    private _onClick_Submit(evt: MouseEvent) {
        //this.close(1);
        evt.stopPropagation();
        if (this.isLocked == true) {
            return;
        }
        this._serializeData();
        this.closeAndSubmit(1);
    }

    private _onClick_Pipette(evt: MouseEvent) {
        evt.stopPropagation();
        if (this.isDeleting == true) return;


        let customTemplate: PEP.EmploymentTemplate = {
            costUnit1: null, costUnit2: null, costUnit3: null, is_on_duty: false, is_no_break: false,
            ...this.selectedEmploymentType
        };

        customTemplate.startTXT = this.resultData.editedData.startTXT;
        customTemplate.endTXT = this.resultData.editedData.endTXT;
        customTemplate.pauseTXT = this.resultData.editedData.pauseTXT;
        customTemplate.is_on_duty = this.resultData.editedData.is_on_duty;
        customTemplate.is_no_break = this.resultData.editedData.is_no_break === true;
        customTemplate.value2 = this.resultData.editedData.pauseTXT;
        customTemplate.ref_empl_booking_status = this.resultData.editedData.bookingStatusID;
        customTemplate.mainLabel = this.resultData.editedData.mainLabel;

        


        if (this.useCostUnits) {
            customTemplate.costUnit1 = { ID: this._data.ref_cost_unit_1.ID, code: this._data.ref_cost_unit_1.code };
            customTemplate.costUnit2 = { ID: this._data.ref_cost_unit_2.ID, code: this._data.ref_cost_unit_2.code };
            customTemplate.costUnit3 = { ID: this._data.ref_cost_unit_3.ID, code: this._data.ref_cost_unit_3.code };
        }

        if (this.useMultipleBreaks) {
            customTemplate.breaks = lang.clone(this._data.breaks);
        }

        this._PepHome.setCustomTemplateMode(customTemplate);
    }

    private _onClick_root(evt: MouseEvent) {
        evt.stopPropagation();
    }

    private _onClick_EmploymentNotesInternal(evt: MouseEvent) {
        evt.stopPropagation();

        this.UiModder.domClass.toggle(this.employmentNotesInternalContainer, "hover");
    }
      _onClick_EmploymentNotes(evt: MouseEvent) {
        evt.stopPropagation();

        this.UiModder.domClass.toggle(this.employmentNotesContainer, "hover");
    }

    private _onChange_InputEmploymentType() {

        this.isOverrideTime = false; // RESET
        
        this.setDataFromSelectedTemplate();
        this._serializeData();
        this.setEmploymentTypeStyle();

        if (FeatureHelpers.hasModuleVersion("PEP", 260200.0000)) {
            this.checkEmploymentTimes();
        } else {
            this._getDelayedPauseDuration();
        }

        if (this.selectedEmploymentType?.ref_empl_booking_status) {
            this.inputBookingStatus.setValue(this.selectedEmploymentType.ref_empl_booking_status, false);
        }

        if (!this.isLocked) {
            this.emit("change", this.resultData.editedData);
        }
    }

    private _onChange_InputBookingStatus() {
        if (this.isLocked) return;
        this.setDataFromSelectedBookingStatus();
        this._serializeData();

        //this.emit("change");
    }

    private _onChange_InputIsOnDuty() {
        if (this.isLocked) return;
        this._serializeData();
        //this.emit("change");
    }

    private _onChange_InputIsNoBreak() {
        if (this.isLocked) return;
        this._serializeData();
        //this.emit("change");
    }

    private _onChange_InputIsTimesConfirmed() {
        if (this.isLocked) return;
        this._serializeData();
        //this.emit("change");

        this.UiModder.domClass.remove(this.employmentConfirmationLabels, "w3-hide");

        if (this.inputIsTimesConfirmed.getValue() == true) {
            this.setTimesConfirmedByLabel();
            //this.UiModder.domClass.add(this.txtTimesConfirmedAt, "obsolete");
            this.UiModder.domClass.remove(this.employmentConfirmationLabels, "obsolete");
            this.UiModder.domClass.add(this.txtTimesConfirmedAt, "w3-hide");
        } else {
            this.UiModder.domClass.add(this.employmentConfirmationLabels, "obsolete");
            this.UiModder.domClass.remove(this.txtTimesConfirmedAt, "obsolete");
        }
    }

    private setTimesConfirmedByLabel(username?: string) {
        if (!username) {
            username = this.getCurrentUserDisplayName();
        }

        if (username == "") {
            this.UiModder.domClass.add(this.txtTimesConfirmedBy, "w3-hide");
        } else {
            this.UiModder.domClass.remove(this.txtTimesConfirmedBy, "w3-hide");
        }
        this.txtTimesConfirmedBy.innerHTML = this.stringFormat(this.translations["PEP_EmploymentEditor__LblIsTimesConfirmedBy"],
            username);

    }

    private _onChange_InputTimeStart() {
        if (this.isLocked) return;
        if (this.selectedEmploymentType && this.selectedEmploymentType.is_can_oversteer_time_values != true) {
            this.inputTimeStart.value = this._data.startTXT;
            return;
        }
        //console.debug("_onChange_InputTimeStart");
        if (FeatureHelpers.hasModuleVersion("PEP", 260200.0000)) {
            this.checkEmploymentTimes();
        } else {
            this._getDelayedPauseDuration();
        }
        
        this.isOverrideTime = true;
        this._data.value1 = "";
        this._serializeDataDelayed();

        //this.emit("change");
    }
    private _onChange_InputTimeEnd() {
        if (this.isLocked) return;
        if (this.selectedEmploymentType && this.selectedEmploymentType.is_can_oversteer_time_values != true) {
            this.inputTimeEnd.value = this._data.endTXT;
            return;
        }
        if (FeatureHelpers.hasModuleVersion("PEP", 260200.0000)) {
            this.checkEmploymentTimes();
        } else {
            this._getDelayedPauseDuration();
        }
        this.isOverrideTime = true;
        this._serializeDataDelayed();
        this._data.value1 = "";
        //this.emit("change");
    }
    private _onChange_InputBreakDuration() {
        if (this.isLocked) return;
        if (this.selectedEmploymentType && this.selectedEmploymentType.is_can_oversteer_time_values != true) {
            this.inputBreakDuration.value = this._data.pauseTXT;
            return;
        }
        this.isOverrideTime = true;
        this._serializeDataDelayed();

        this.checkEmploymentTimes();
        //this.emit("change");
    }

    private _getDelayedPauseDuration(delay?: number) {
        this.disableNode(this.actionContainer);
        this._tryClearPauseTimeout();
        this._getPauseTimeout = setTimeout(lang.hitch(this, this._getCalculatedPauseDuration), delay ? delay : 888);
    }
    private _getPauseTimeout: number = null;
    private _tryClearPauseTimeout(): void {
        if (this._getPauseTimeout != null) {
            clearTimeout(this._getPauseTimeout);
        }

        this._getPauseTimeout = null;
    }
    private _tryCancelPauseRequest(): void {
        if (this._getPauseRequest != null) {
            this._getPauseRequest.cancel();
            this._getPauseRequest = null;
        }
    }

    private _getCalculatedPauseDuration(): void {

        this._tryCancelPauseRequest();
        this._tryClearPauseTimeout();

        if (this.useMultipleBreaks || FeatureHelpers.hasModuleVersion("PEP", 260200.0000)) {
            this._checkEmploymentTimes();
            return;
        }

        this.StandbyStart(this.sectionBreak);


        let data = this.resultData;


        this._getPauseRequest = this.RequestManager.callfunction(
            "Webtool_API_PEP__GetPauseDurationJSON",
            data,
            lang.hitch(this, this._onGetPauseDurationResponse),
            lang.hitch(this, this._onGetPauseDurationError)
        );
    }

    private _onGetPauseDurationResponse(response: any): void {
        this._getPauseRequest = null;

        let pause = response.duration_pause ? response.duration_pause.toFixed(2) : null;
        pause ? this.inputBreakDuration.value = pause : this.inputBreakDuration.value = "";

        //console.debug("_onGetPauseDurationResponse", response, pause, parseFloat(pause));

        this._onChange_InputBreakDuration();

        this.disableNode(this.actionContainer, false);
        this.StandbyStop();
    }

    private _onGetPauseDurationError(response: any): void {
        this._getPauseRequest = null;
        this.disableNode(this.actionContainer, false);
        this.StandbyStop();

        alert("Fehler bei Pauseberechnung!\r\n" + response.Message);

        console.error("_onGetPauseDurationError", response.Message);
    }
   
    private _onChange_InputNotes() {
        // DEAKTIVIERT - Anmerkungen werden nicht mehr im Diensteditor bearbeitet!
    //    this.convertNewData();
    //    this.emit("change");
    }

    private _onChange_InputNotesInternal() {
        // DEAKTIVIERT - Anmerkungen werden nicht mehr im Diensteditor bearbeitet!
    //    this.convertNewData();
    //    this.emit("change");
    }

    private _onChangeCostUnit1() {
        let value = this.inputCostUnit1.getValue();
        //console.debug("employmentEditor _onChangeCostUnit1", value);

        if (typeof (value) == "object" && typeof (value) != "undefined" && value != null) {
            this.CostUnit1 = { ID: value.ID, code: value.code };
        }
        else {
            this.CostUnit1 = null;
        }

        this._serializeData();
    }

    private _onKeyUp_InputNotes() {
        this._serializeDataDelayed();
    }
     private _onKeyUp_InputNotesInternal() {
        this._serializeDataDelayed();
    }

    postMixInProperties(args?: any): void {
        super.postMixInProperties.apply(this, arguments as any);


        this.windowEx = window as any;
    }
    destroy(): void {
        try {
            if (this._checkEmploymentTimesRequest) {
                this._checkEmploymentTimesRequest.cancel();
            }
            if (this._getPauseRequest) {
                this._getPauseRequest.cancel();
            }
        } catch (ex) {

        }
        super.destroy.apply(this, arguments as any);
    }

    private _pageStack: MdsLax<InstanceType<typeof PageStack>>;
    private _previousPageName: string;
    private sectionMain: HTMLElement;
    private sectionEntityView: HTMLElement;
    private upperContainer: HTMLElement;
    postCreate(): void {

        this.addSubscription("PEP/RegistryLoaded", lang.hitch(this, this._initValuesFromRegistry));
        super.postCreate.apply(this, arguments as any);

        this._PepHome = this.windowEx.PepHome;

        this.breaksReg = [];

        this.useMultipleBreaks = FeatureHelpers.hasFeature("PEP/useMultipleBreaks");
        this.useCostUnits = FeatureHelpers.hasFeature("PEP/useCostUnits");


        this.disableNode(this.sectionSingleBreak, this.useMultipleBreaks);

        this.hideNode(this.sectionIsOnDuty, !FeatureHelpers.hasFeature("PEP/useCheckboxOnDuty"));
        this.hideNode(this.sectionNoBreak, !FeatureHelpers.hasFeature("PEP/useCheckboxNoBreak"));

        let settings = FeatureHelpers.getModuleProperty<_EmploymentEditorSettings>("PEP", "employmentEditor");
        if (settings) this._settings = settings;

        this._pageStack = new PageStack();
        this._pageStack.hideTabRow(true);
        this._pageStack.on("pageChange", lang.hitch(this, function (name: string) { this._previousPageName = name; }));

        this._pageStack.placeAt(this.upperContainer, "first");

        this._pageStack.addPage(this.sectionMain, {
            label: "PEP_EmploymentEditor__LblPageEditor",
            name: "editor",
            //insertWithoutPadding: true,
            iconclass: "fas fa-edit"
        });

        // Pagestack vorbereiten falls gewünscht:
        if (FeatureHelpers.hasFeature("PEP/EntityViewInEditor")) {
            this.useEntityView = true;
            this._pageStack.hideTabRow(false);
            this._pageStack.addPage(this.sectionEntityView, {
                label: "PEP_EmploymentEditor__LblPageEntityview",
                name: "entityview",
                //insertWithoutPadding: true,
                iconclass: "fas fa-info-circle",
                coloration: "#1111ff"
            });

            this.hideNode(this.sectionEntityView, false);
        }

        this._initValuesFromRegistry();
    }

    setupHintboxes(): void {

        this.inputCostUnit1.removeRequestParams();
        this.inputCostUnit1.addRequestProperty("jsonData", { "employment": this._data });
        this.inputCostUnit1.setValue(this._data.ref_cost_unit_1, true);
        //this.inputCostUnit1.addRequestParam("schas", "abcdefgh");
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(PepEmploymentEditor);